export default function TrustBar() {
  const items = [
    'AI-powered automation',
    'Built for travel agencies',
    'No coding required',
    'WhatsApp & CRM integrated',
    'GDPR compliant',
  ];

  return (
    <section className="border-y border-gray-100 bg-gray-50 py-5 overflow-hidden">
      <div className="flex items-center justify-center flex-wrap gap-x-10 gap-y-3 px-6">
        {items.map((item, i) => (
          <div key={item} className="flex items-center gap-3">
            {i !== 0 && <span className="hidden sm:block w-1 h-1 rounded-full bg-gray-300" />}
            <span className="text-sm text-gray-500 font-medium whitespace-nowrap">{item}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
